import React, {createContext, useState} from 'react';
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";


const MyAuthContext = createContext();

const MyAuthProvider = ({ children }) => {
    const [error, setError] = useState({"error": false, "message": ""});
    const [user, setUser] = useState({});
    const [credentials, setCredentials] = useState({});
    const [loading, setLoading] = useState(false);

    const registerUser = async ( data ) => {
        setLoading(true)
        try{
            const res = await axios.post(`${API}/user/register`, data)
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const login = async (data) => {
        setLoading(true);
        try{
            const res = await axios.post(`${API}/user/login`, data);
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const recoverPasswordGenerate = async (data) => {
        setLoading(true);
        try{
            const res = await axios.post(`${API}/user/recoverpassword/generate`, data);
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }
    
    const recoverPasswordChange = async (data) => {
        setLoading(true);
        try{
            const res = await axios.post(`${API}/user/recoverpassword/change`, data);
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }
    const verificateAccount = async (data) => {
        setLoading(true);
        try{
            const res = await axios.post(`${API}/user/verificate`, data);
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const getUser = async () => {
        try{
            const res = await axios.get(`${API}/user/user`, config);
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                setUser(res.data.response);
            }
        } catch(err){
            return;
        }
    }

    const updateUser = async (data) => {
        setLoading(true);
        try{
            const res = await axios.put(`${API}/user/update`, data, config);
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getUser();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const sendEmailContact = async (data) => {
        setLoading(true);
        try{
            const res = await axios.post(`${API}/user/contact`, data);
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }
    return(
        <MyAuthContext.Provider value={{
            error,
            user,
            credentials,
            setError,
            setUser,
            setCredentials,
            registerUser,
            login,
            sendEmailContact,
            loading,
            recoverPasswordGenerate,
            recoverPasswordChange,
            getUser,
            verificateAccount,
            updateUser
        }}>
            {children}
        </MyAuthContext.Provider>
    )

}

export { MyAuthProvider };
export default MyAuthContext;